var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCIconoVideo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#444;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15,28.3A13.3,13.3,0,1,1,28.3,15,13.4,13.4,0,0,1,15,28.3ZM15,3.5A11.5,11.5,0,1,0,26.5,15,11.6,11.6,0,0,0,15,3.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.7,22.5h-.4a1,1,0,0,1-.5-.8V8.4a1,1,0,0,1,.5-.8,1,1,0,0,1,.9.1l9.9,6.6a.7.7,0,0,1,.4.7.7.7,0,0,1-.4.7l-9.9,6.6Zm.9-12.4v9.8L20,15Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCIconoVideo);
export default __webpack_public_path__ + "static/media/c-icono-video.9916dbff.svg";
export { ForwardRef as ReactComponent };